var a="\n    Normal = normalize(localPos + matrix_viewInverse[2].xyz);\n";export{a as default};
